"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var withStoreProp = function withStoreProp(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(_reactRedux.ReactReduxContext.Consumer, null, function (_ref) {
      var store = _ref.store;
      return /*#__PURE__*/_react.default.createElement(Component, Object.assign({}, props, {
        store: store
      }));
    });
  };
};

var _default = withStoreProp;
exports.default = _default;